"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var styled_component_helpers_1 = require("./styled-component-helpers");

var Typography_1 = require("./Typography");

var Link_1 = require("./Link");

var Circle = function Circle(props) {
  var size = props.size,
      border = props.border,
      borderColor = props.borderColor,
      borderHover = props.borderHover,
      borderHoverColor = props.borderHoverColor,
      color = props.color,
      smallFactor = props.smallFactor;
  return React.createElement(CircleWrapper, null, React.createElement(exports.CircleBackground, {
    fillSize: size - 2 * border,
    fillColor: color,
    border: border,
    borderColor: borderColor,
    borderHover: borderHover,
    borderHoverColor: borderHoverColor,
    smallFactor: smallFactor
  }, React.createElement(CircleContent, {
    secondary: true
  }, props.children)), props.label && React.createElement(exports.CircleLabel, null, props.label));
};

exports["default"] = Circle;
Circle.defaultProps = {
  size: 96,
  color: styled_component_helpers_1.themeProp(styled_component_helpers_1.lightTheme, 'global.accentColor'),
  border: 0,
  borderHover: 2,
  borderColor: styled_component_helpers_1.themeProp(styled_component_helpers_1.lightTheme, 'circle.borderColor'),
  borderLinkColor: styled_component_helpers_1.themeProp(styled_component_helpers_1.lightTheme, 'circle.link.borderColor'),
  borderHoverColor: styled_component_helpers_1.themeProp(styled_component_helpers_1.lightTheme, 'circle.link.hover.borderColor'),
  smallFactor: 1
};
var CircleWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  vertical-align: middle;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  vertical-align: middle;\n  align-items: center;\n"])));
exports.CircleBackground = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  background-color: ", ";\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  border: ", "px solid ", ";\n  .hasHover ", " & {\n    border-color: ", ";\n  }\n  .hasHover ", ":hover & {\n    border-width: ", "px;\n    border-color: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    border-radius: ", "px;\n    width: ", "px;\n    height: ", "px;\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  background-color: ", ";\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  border: ", "px solid ", ";\n  .hasHover ", " & {\n    border-color: ", ";\n  }\n  .hasHover ", ":hover & {\n    border-width: ", "px;\n    border-color: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    border-radius: ", "px;\n    width: ", "px;\n    height: ", "px;\n  }\n"])), function (props) {
  return props.fillColor;
}, function (props) {
  return props.fillSize * props.smallFactor;
}, function (props) {
  return props.fillSize * props.smallFactor;
}, function (props) {
  return (props.fillSize * props.smallFactor + 2 * props.border) / 2;
}, function (props) {
  return props.border;
}, function (props) {
  return props.borderColor;
}, Link_1.LinkStyled, function (props) {
  return props.borderLinkColor;
}, Link_1.LinkStyled, function (props) {
  return props.borderHover;
}, function (props) {
  return props.borderHoverColor;
}, styled_component_helpers_1.bp.medium2, function (props) {
  return (props.fillSize + 2 * props.border) / 2;
}, function (props) {
  return props.fillSize;
}, function (props) {
  return props.fillSize;
});
var CircleContent = styled_components_1["default"](Typography_1.TextStyles.style4)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: bold;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  & > img {\n    display: block;\n  }\n"], ["\n  font-weight: bold;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  & > img {\n    display: block;\n  }\n"])));
exports.CircleLabel = styled_components_1["default"](Typography_1.TextStyles.textAction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: ", "px;\n  .hasHover ", ":hover & {\n    color: ", ";\n  }\n"], ["\n  margin-top: ", "px;\n  .hasHover ", ":hover & {\n    color: ", ";\n  }\n"])), styled_component_helpers_1.units.headingSeparator, Link_1.LinkStyled, styled_component_helpers_1.theme('circle.link.hover.borderColor'));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;